export default {
  items: [
    "Acehnese",
    "Acholi",
    "Afghan",
    "African American",
    "African, so described",
    "Afrikaner",
    "Akan",
    "Albanian",
    "Algerian",
    "American",
    "Amhara",
    "Anglo-Burmese",
    "Anglo-Indian",
    "Angolan",
    "Arab, nfd",
    "Argentinian",
    "Armenian",
    "Assyrian",
    "Australian",
    "Australian Aboriginal",
    "Australian Aboriginal and Torres Strait Islander",
    "Australian South Sea Islander",
    "Austrian",
    "Azeri",
    "Balinese",
    "Bangladeshi",
    "Barbadian",
    "Basque",
    "Batswana",
    "Belarusan",
    "Belgian",
    "Bengali",
    "Berber",
    "Bermudan",
    "Bhutanese",
    "Bolivian",
    "Bosnian",
    "Brazilian",
    "Bruneian",
    "Bulgarian",
    "Burgher",
    "Burmese",
    "Burundian",
    "Cameroonian",
    "Canadian",
    "Catalan",
    "Chaldean",
    "Channel Islander",
    "Chilean",
    "Chin",
    "Chinese",
    "Colombian",
    "Congolese",
    "Cook Islander",
    "Coptic",
    "Costa Rican",
    "Creole, so described",
    "Croatian",
    "Cuban",
    "Cypriot",
    "Czech",
    "Danish",
    "Dinka",
    "Dutch",
    "Ecuadorian",
    "Egyptian",
    "English",
    "Eritrean",
    "Estonian",
    "Ethiopian",
    "Fijian",
    "Fijian Indian",
    "Filipino",
    "Finnish",
    "Flemish",
    "French",
    "French Canadian",
    "Frisian",
    "Georgian",
    "German",
    "Ghanaian",
    "Gibraltarian",
    "Greek",
    "Guatemalan",
    "Gujarati",
    "Guyanese",
    "Hawaiian",
    "Hazara",
    "Hispanic North American",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "I-Kiribati",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Italian",
    "Ivorean",
    "Jamaican",
    "Japanese",
    "Javanese",
    "Jewish",
    "Jordanian",
    "Kadazan",
    "Karen",
    "Kashmiri",
    "Kazakh",
    "Kenyan",
    "Khmer (Cambodian)",
    "Korean",
    "Kurdish",
    "Kuwaiti",
    "Kyrgyz",
    "Lao",
    "Latvian",
    "Lebanese",
    "Liberian",
    "Libyan",
    "Lithuanian",
    "Luxembourg",
    "Macedonian",
    "Madi",
    "Malawian",
    "Malay",
    "Malayali",
    "Maldivian",
    "Maltese",
    "Manx",
    "Maori",
    "Mauritian",
    "Mayan",
    "Mexican",
    "Moldovan",
    "Mon",
    "Mongolian",
    "Montenegrin",
    "Moroccan",
    "Mozambican",
    "Namibian",
    "Native North American Indian",
    "Nepalese",
    "New Zealander",
    "Nicaraguan",
    "Nigerian",
    "Niuean",
    "Ni-Vanuatu",
    "Norwegian",
    "Nuer",
    "Omani",
    "Oromo",
    "Pakistani",
    "Palestinian",
    "Papua New Guinean",
    "Paraguayan",
    "Pathan",
    "Peruvian",
    "Polish",
    "Portuguese",
    "Puerto Rican",
    "Punjabi",
    "Roma Gypsy",
    "Romanian",
    "Russian",
    "Rwandan",
    "Salvadoran",
    "Samoan",
    "Saudi Arabian",
    "Scottish",
    "Senegalese",
    "Serbian",
    "Seychellois",
    "Shona",
    "Sierra Leonean",
    "Sikh",
    "Sindhi",
    "Singaporean",
    "Sinhalese",
    "Slovak",
    "Slovene",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Sudanese",
    "Spanish",
    "Sri Lankan",
    "Sri Lankan Tamil",
    "Sudanese",
    "Sundanese",
    "Swahili",
    "Swazilander",
    "Swedish",
    "Swiss",
    "Syrian",
    "Tahitian",
    "Taiwanese",
    "Tajik",
    "Tamil, nfd",
    "Tanzanian",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrayan",
    "Tigre",
    "Timorese",
    "Togolese",
    "Tokelauan",
    "Tongan",
    "Torres Strait Islander",
    "Trinidadian Tobagonian",
    "Tunisian",
    "Turkish",
    "Turkmen",
    "Tuvaluan",
    "Ugandan",
    "Uighur",
    "Ukrainian",
    "Uruguayan",
    "Uzbek",
    "Venezuelan",
    "Vietnamese",
    "Welsh",
    "Yemeni",
    "Yoruba",
    "Zambian",
    "Zimbabwean",
    "Zulu"
    ],
};



// WEBPACK FOOTER //
// ../data/wa/ancestry.js